// extracted by mini-css-extract-plugin
module.exports = {"body":"_a86d778"};